import { render } from "./VolunteeringConversation.vue?vue&type=template&id=57bd5424&scoped=true"
import script from "./VolunteeringConversation.vue?vue&type=script&lang=js"
export * from "./VolunteeringConversation.vue?vue&type=script&lang=js"

import "./VolunteeringConversation.vue?vue&type=style&index=0&id=57bd5424&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-57bd5424"

export default script